<template>
  <esg026 />
</template>

<script>
import esg026 from '@/pages/esg/p_esg026.vue';
// import { TToggleButton } from '@/components/TToggle';

export default {
  components: {
    esg026,
    // TToggleButton
  },
};
</script>
